import { DropDown } from "@swa-ui/core";

import { withFormField } from "../withFormField";

/**
 * SelectFormField provides support for a standard DropDown component to be used in a Form.
 */

export const SelectFormField = withFormField(DropDown, { useController: true });
